<template>
  <div class="note-box" :class="{ showPopup: isShow }">
    <a-spin wrapperClassName="list-spin" tip="加载中..." :spinning="loading">
      <div class="note-top">
        <div class="top-title">疑问</div>
        <div>
          <a-tooltip title="新增疑问">
            <svg class="icon-svg" @click="updateNote(null)">
              <use xlink:href="#icon-add-question" />
            </svg>
          </a-tooltip>
          <a-tooltip title="关闭">
            <svg class="icon-svg icon-close" @click="close()">
              <use xlink:href="#icon-close" />
            </svg>
          </a-tooltip>
        </div>
      </div>
      <div class="note-list">
        <div class="note-item-box" v-for="note in noteList" :key="note.uid">
          <div class="note-item">
            <div class="note-item-top">
              <div>
                <i class="user-head" :style="{ backgroundImage: 'url(' + note?.headPhotoPath + ')' }"></i>
                <span class="user-name">{{ note.userName }}</span>
                <span class="update-time">{{ note.updateTime }}</span>
              </div>
              <div>
                <div class="note-handler">
                  <a-tooltip title="删除疑问" v-if="note.isMine">
                    <svg class="icon-svg icon-delete" @click="deleteNote(note)">
                      <use xlink:href="#icon-delete2" />
                    </svg>
                  </a-tooltip>
                </div>
                <div class="note-reply" @click="openReply(note)">回复</div>
              </div>
            </div>
            <div class="note-info">
              <div class="note-text" v-if="note.text" @click="chooseNote(note)">
                <i class="note-mark"></i>
                <span>{{ note.text }}</span>
              </div>
              <div class="note-content-text">
                <span class="note-question">?</span>
                <span>{{ note.content }}</span>
              </div>
            </div>
          </div>
          <div class="note-item-box comment-item-box" v-for="comment in note.comments">
            <div class="note-time" v-if="comment.updateTime">{{ comment.updateTime }}</div>
            <div class="note-item">
              <div class="note-item-top">
                <div>
                  <i class="user-head" :style="{ backgroundImage: 'url(' + comment?.headPhotoPath + ')' }"></i>
                  <div class="user-name">{{ comment.userName }}</div>
                </div>
              </div>
              <div class="note-info">
                <div class="note-content">{{ comment.content }}</div>
              </div>
              <div class="note-handler">
                <span class="update-time">{{ comment.createTime }}</span>
                <a-tooltip v-if="comment.isMine || note.isMine">
                  <template #title>删除回复</template>
                  <svg class="icon-svg icon-delete" @click="deleteComment(note, comment)">
                    <use xlink:href="#icon-delete2" />
                  </svg>
                </a-tooltip>
              </div>
            </div>
          </div>

          <div class="new-reply fadeIn" v-if="note.replying">
            <textarea class="textarea" v-focus v-model="note.replyContent" placeholder="写下你的观点，互通有无..."></textarea>
            <div class="bottom-handler">
              <a-tooltip>
                <template #title>删除</template>
                <svg class="icon-svg icon-delete" @click="closeReply(note)">
                  <use xlink:href="#icon-delete2" />
                </svg>
              </a-tooltip>
              <a-tooltip>
                <template #title>提交</template>
                <svg class="icon-svg icon-push" @click="pushReply(note)">
                  <use xlink:href="#icon-push" />
                </svg>
              </a-tooltip>
            </div>
          </div>
        </div>
        <a-empty v-if="noteList.length == 0" description="还没有任何疑问" />
      </div>
    </a-spin>
    <addQuestion :newNoteId="newNoteId" :userNote="userNote" @refreshList="refreshList" @newUserNote="newUserNote"
      @closeUpdate="closeUpdate()" v-if="userNote"></addQuestion>
  </div>
</template>
<script>
import addQuestion from './add-question/add-question.vue';
import UUID from 'uuid';

export default {
  name: 'question-box',
  components: {
    addQuestion
  },
  props: {
    chapter_num: Number,
    allNote: Array,
    questionData: Array
  },
  data() {
    return {
      userId: '',
      classId: '',

      userNote: null,
      newNoteId: null,

      intList: [],
      noteList: [],

      isShow: false,
      loading: false,

      isReplying: false,
      isDeleting: false
    }
  },
  mounted() {
    let { intList, userInfo, currentClass } = this.$store.state;
    this.intList = intList;
    this.userInfo = userInfo;
    this.userId = userInfo.PK_UserGuid;
    this.classId = currentClass.PK_ClassGuid;

    let chapter_num = this.chapter_num || 0;
    this.fk_unitId = this.intList[chapter_num].PK_InductionGuid;

    //按时间排序
    this.noteList = JSON.parse(JSON.stringify(this.questionData));
    this.noteList.sort((a, b) => {
      return new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime();
    })
    this.$store.subscribe((res) => {
      if (!res) return;
      let { type, payload } = res;

      if (type == "pilotNavOpen") {
        this.isShow = payload === 'question';
        if (this.isShow) this.clearNewComment();
      }
    })
  },
  watch: {
    questionData: {
      handler(val) {
        this.noteList = JSON.parse(JSON.stringify(val));
        this.noteList.sort((a, b) => {
          return new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime();
        })
      },
      deep: true
    },
    chapter_num(val) {
      this.fk_unitId = this.intList[val].PK_InductionGuid;
    }
  },

  methods: {
    //选择note
    chooseNote(note) {
      this.$emit('chooseNote', note);
    },
    //更新note
    updateNote(uid) {
      if (this.userNote) return this.userNote = null;

      let userNote;
      if (uid == null) {
        uid = UUID.v1();
        let newNote = {
          uid,
          public: true,
          type: "unit",
          content: null,
          updateTime: this.$moment().format('YYYY-MM-DD HH:mm:ss').toString(),
          noteType: "question",
        }

        userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_unitId == this.fk_unitId);

        if (userNote) userNote.notes.push(newNote);
        else {
          userNote = {
            fk_classId: this.classId,
            fk_studentId: this.userId,
            fk_unitId: this.fk_unitId,
            fk_trainId: '',
            notes: [newNote]
          }
        }
      }
      else userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_unitId == this.fk_unitId);
      this.userNote = userNote;
      this.newNoteId = uid;
    },
    //新建note
    newUserNote(userNote) {
      this.userNote = userNote;
    },

    //更新列表
    refreshList(note) {
      let noteList = this.noteList;
      let oldnote = noteList.find(item => note.uid == item.uid);
      if (oldnote) {
        noteList.forEach(item => {
          if (item.uid == note.uid) {
            item.content = note.content;
            item.public = note.public;
          }
        })
      }
      else {
        let userNote = this.userNote;
        noteList.unshift({
          _id: userNote._id,
          fk_studentId: userNote.fk_studentId,
          fk_trainId: userNote.fk_trainId,
          fk_unitId: userNote.fk_unitId,
          userName: this.userInfo.Name,
          headPhotoPath: this.userInfo.HeadPhotoPath,
          isMine: true,
          ...note
        })
      }
      this.noteList = noteList;
      this.closeUpdate();
    },
    //删除note
    async deleteNote(note) {
      if (this.isDeleting) return;
      this.isDeleting = true;

      let userNote;
      if (note.fk_unitId) userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_unitId == note.fk_unitId);
      else userNote = this.allNote.find(item => item.fk_studentId == this.userId && item.fk_trainId == note.fk_trainId);
      if (!userNote) return;
      userNote.notes = userNote.notes.filter(item => item.uid != note.uid);

      let newData = JSON.parse(JSON.stringify(userNote));
      delete newData._id;

      let res = await this.$api.note.createOrUpdate(newData);
      this.isDeleting = false;
      if (res.statusCode != 200) return this.$message.warning(res.message);

      this.$message.success('删除疑问成功');
      this.noteList = this.noteList.filter(item => item.uid != note.uid);


      this.$emit('refreshNote', note)
      this.closeUpdate();
    },
    //折叠
    close() {
      this.$store.commit('pilotNavOpen', '');
      this.closeUpdate();
    },
    //关闭修改框
    closeUpdate() {
      this.userNote = null;
      this.newNoteId = null;
    },
    ///////////////////////////////////////////////
    //打开回复
    openReply(note) {
      note.replying = !note.replying;

      if (!note.replying) return

      note.replyContent = '';
    },
    //回复
    async pushReply(note) {
      if (this.isReplying) return;

      note.replyContent = note.replyContent ? note.replyContent.trim() : '';

      if (note.replyContent == '') return this.$message.warning('请输入回复');

      this.isReplying = true;
      let newReply = {
        id: note._id,
        uid: note.uid,
        comment: {
          studentId: this.userId,
          content: note.replyContent
        }
      }
      let res = await this.$api.note.createComment(newReply);
      this.isReplying = false;
      if (res.statusCode != 200) return this.$message.warning(res.message)
      this.$message.success('回复成功');

      this.noteList.forEach(item => {
        if (item.uid == note.uid) {
          item.comments = item.comments || [];
          item.comments.push({
            id: res.data.id,
            createTime: res.data.createTime,
            studentId: this.userId,
            content: note.replyContent,
            userName: this.userInfo.Name,
            headPhotoPath: this.userInfo.HeadPhotoPath,
            isMine: true,
            isNew: true
          })
        }
      })

      this.closeReply(note);
    },
    //关闭回复
    closeReply(note) {
      note.replyContent = '';
      note.replying = false;
    },
    //删除回复
    async deleteComment(node, comment) {
      if (this.isDeleting) return;

      this.isDeleting = true;

      let res = await this.$api.note.deleteComment(node._id, node.uid, comment.id);
      this.isDeleting = false;
      if (res.statusCode != 200) return this.$message.warning(res.message);

      node.comments = node.comments.filter(item => item.id != comment.id);
      this.$message.success('删除回复成功');

    },
    //清除新回复
    async clearNewComment() {
      let commentIdList = [];
      this.noteList.forEach(note => {
        note.comments.forEach(comment => {
          if (comment.isNew) {
            comment.isNew = false;
            commentIdList.push(comment.id);
          }
        })
      })
      if (commentIdList.length == 0) return;

      await this.$api.note.readComment(this.classId, commentIdList);
      this.$store.commit('newReply', 0);
    }
  },
}


</script>

<style scoped lang="scss">
@import "./question-box.scss";
</style>